module.exports = __webpack_public_path__ + "assets/5f6a79921cce07336b67a04fac013db7.mp3";